module.exports = __webpack_public_path__ + "assets/img/wallpaper-default-uncompressed.7175cec3.png";